/**
 * Mock 模块：union_city_war_pk_list
 * @see mockMd/union_city_war_pk_list.md
 */
import {storiesAvatar} from '../components/PkBattleDrawer/stories-images'
import type {UnionCityWarPkListData, UnionCityWarPkSideItem} from '../types'

const MOCK_USER_AVATAR = storiesAvatar

const pkSide = (
  id: number,
  name: string,
  score: number,
  robot = false,
  avatar = MOCK_USER_AVATAR
): UnionCityWarPkSideItem => ({
  union_id: id,
  union_name: name,
  union_avatar: avatar,
  city_score: score,
  is_robot: robot,
})

const pkMatch = () => ({
  left: pkSide(
    100001,
    '1USER NAME US...',
    100000,
    false,
    'https://img01.mehiya.com/img/png/id/351705097366'
  ),
  right: pkSide(100002, '2USER NAME US...', 200000),
})

/** 对齐 PK战况半屏-常态 4 行对局 */
/** @see mockMd/union_city_war_pk_list.md */
export const UnionCityWarPkListMock: UnionCityWarPkListData = {
  err_msg: '',
  page: 1,
  more: false,
  list: [pkMatch(), pkMatch(), pkMatch(), pkMatch()],
}

/** @see mockMd/union_city_war_pk_list.md */
export const UnionCityWarPkListEmptyMock: UnionCityWarPkListData = {
  err_msg: '',
  page: 1,
  more: false,
  list: [],
}
